import { cn } from '@/shared/lib/cn';
import type { SummaryRow } from '../model/checkout-summary';

export function SummaryList({ rows }: { rows: readonly SummaryRow[] }) {
  return (
    <dl className="flex flex-col">
      {rows.map((row) => (
        <div
          key={row.key}
          className="flex justify-between gap-4 border-line py-2.5 not-first:border-t"
        >
          <dt className={cn(!row.isTotal && 'text-muted')}>{row.label}</dt>
          <dd
            className={cn(
              'text-right tabular-nums',
              row.isTotal ? 'font-semibold' : row.key === 'plan' && 'font-medium',
            )}
          >
            {row.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
